import AppDataService from "./AppDataService";
const COMMON_BASE = "StatePayroll"

export default class StatePayrollDataService {
    static async getStateNamesList(){
        return await AppDataService.get(`${COMMON_BASE}/StateNames`)
    }
    static async getStatePayrollFormsList(params){
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollForms?stateName=${params}`)
    }
}